import api from "../index";

// Keš na nivou sesije — javne stranice ne pozivaju API pri svakoj
// promeni rute, a admin nakon čuvanja ažurira keš da se promena
// odmah vidi bez reload-a
let promoTickerCache = null;

const settingsService = {
  // Public: promo ticker config (enabled + text)
  getPromoTicker: async () => {
    const response = await api.get("/settings/promo-ticker");
    return response.data;
  },

  getPromoTickerCached: async () => {
    if (promoTickerCache) return promoTickerCache;
    const data = await settingsService.getPromoTicker();
    promoTickerCache = data?.promoTicker || { enabled: false, text: "" };
    return promoTickerCache;
  },

  setPromoTickerCache: (value) => {
    promoTickerCache = value;
  },
};

export default settingsService;
